module.exports = __webpack_public_path__ + "img/icon-hook.0c3d4db9.svg";